import { action, observable, makeObservable } from "mobx";
import { api } from "../lib/api";
import { appHistory } from "../appHistory";
import { ApiError, IApiBody } from "../models/api";
import { IApiResponseErrors } from "../models/apiResponses";
import { SharedStateStore } from "./SharedStateStore";

const NO_ERRORS: IApiResponseErrors & {
  password?: string[];
  confirmPassword?: string[];
} = {
  non_field_errors: [],
  password: [],
  confirmPassword: []
};

export class PasswordResetPageStore extends SharedStateStore {
  validToken = false;

  resetPasswordSuccess = false;

  sendingEmail = false;

  password = "";

  confirmPassword = "";

  errors = {
    ...NO_ERRORS
  };

  params: IApiBody = {};

  errorCode: number | undefined;

  constructor() {
    super()

    makeObservable(this, {
      validToken: observable,
      resetPasswordSuccess: observable,
      sendingEmail: observable,
      password: observable,
      confirmPassword: observable,
      errors: observable,
      params: observable,
      errorCode: observable,
      activate: action,
      resetPassword: action
    });
  }

  async activate(params: IApiBody) {
    if (Object.keys(params).length === 0) {
      return;
    }

    this.params = params;
    try {
      await api.update("password-reset",
      params,
      {
        dontIncludeJwt: true
      });
      this.setState({ validToken: true })
    } catch (err) {
      appHistory.push("/login");
    }
  }

  async resetPassword() {
    if (this.sendingEmail) return;

    this.errors = { ...NO_ERRORS };
    this.sendingEmail = true;

    if (this.password !== this.confirmPassword) {
      this.errors = {
        ...this.errors,
        password: ["Your passwords do not match."]
      };
      this.sendingEmail = false;
      return;
    }

    try {
      await api.update("password-reset", {
        ...this.params,
        password: this.password
      },
      {
        dontIncludeJwt: true
      }
      );

      this.setState({ resetPasswordSuccess: true })
    } catch (error) {
      this.setState({
        errors: (error as ApiError).errorPayload,
        errorCode: (error as ApiError).statusCode,
        sendingEmail: false
      })
    }
  }
}
